import { useEffect, useState } from "react";

import useDebounce from "../../../../hooks/useDebounce";
import {
  BasicCustomFilterProps,
  RangeFilter,
} from "../../../molecules/Filters/RangeFilter";

type props = {
  customFilters: BasicCustomFilterProps[];
  disabledInGameAttributes: boolean;
};

export const DebouncedRangeFilter = ({
  label,
  onChangeMin,
  onChangeMax,
  minValue,
  maxValue,
  isTitle,
}: BasicCustomFilterProps & { isTitle: boolean }) => {
  // Local state for immediate updates
  const [localMinValue, setLocalMinValue] = useState(minValue);
  const [localMaxValue, setLocalMaxValue] = useState(maxValue);

  // Debounce the local values
  const { debouncedSearchTerm: debouncedMinValue } = useDebounce(localMinValue);
  const { debouncedSearchTerm: debouncedMaxValue } = useDebounce(localMaxValue);

  // Update local state when props change
  useEffect(() => {
    setLocalMinValue(minValue);
  }, [minValue]);

  useEffect(() => {
    setLocalMaxValue(maxValue);
  }, [maxValue]);

  // Call the handlers when debounced values change
  useEffect(() => {
    if (debouncedMinValue !== minValue) {
      onChangeMin(debouncedMinValue);
    }
  }, [debouncedMinValue, minValue, onChangeMin]);

  useEffect(() => {
    if (debouncedMaxValue !== maxValue) {
      onChangeMax(debouncedMaxValue);
    }
  }, [debouncedMaxValue, maxValue, onChangeMax]);

  return (
    <RangeFilter
      label={label}
      onChangeMin={setLocalMinValue}
      onChangeMax={setLocalMaxValue}
      minValue={localMinValue}
      maxValue={localMaxValue}
      isTitle={isTitle}
    />
  );
};

export const CustomFilterSection = ({
  customFilters,
  disabledInGameAttributes,
}: props) => {
  return (
    <div className="flex flex-col p-1 rounded-lg gap-y-0.5 bg-white/5">
      {customFilters.map((customFilter) => {
        return (
          (!disabledInGameAttributes || customFilter.isTitle) && (
            <DebouncedRangeFilter
              key={customFilter.label}
              {...customFilter}
              isTitle={!!customFilter.isTitle}
            />
          )
        );
      })}
    </div>
  );
};
